import { z } from "zod";

//QualidadeItemProcessosRiscosInteresseSchema

const optionalNumber =z.number().int().nullable().optional();
const optionalString = z.string().trim().nullable().optional().transform(e => e === '' ? null : e);
export const QualidadeItemProcessosRiscosInteresseSchema = z.object({
    IdItemProcessoInteresse: optionalNumber,
    IdItemProcesso: optionalNumber,
    Descricao: optionalString,
    Expectativa: optionalString,
    Acompanhamento: optionalString,
    ResultadosAlcancados: optionalString,
});

// QualidadeItemProcessosRiscosInteresseForm

export type QualidadeItemProcessosRiscosInteresseForm = z.infer<typeof QualidadeItemProcessosRiscosInteresseSchema>;